import Cookies from 'js-cookie';
import MegaModal from './MegaModal';

function LandingModalMessage () {

    var self = this;

    this.init = function () {
        const content = document.getElementById('landingDialog');

        if (!content) {
            return;
        }

        this._rememberCookieName = content.getAttribute('data-remember-cookie');
        this._removeCookieName = content.getAttribute('data-remove-cookie');
        this._modal = getModal();
        showModal();
    };

    function saveCookie () {
        if (self._rememberCookieName) {
            Cookies.set(self._rememberCookieName, 1, { expires: 365 });
        }

        if (self._removeCookieName) {
            Cookies.remove(self._removeCookieName);
        }
    }

    function wasCookieSaved () {
        if (self._rememberCookieName) {
            return Cookies.get(self._rememberCookieName) === '1';
        }

        if (self._removeCookieName) {
            return !Cookies.get(self._rememberCookieName);
        }
        return false;
    }

    function eventInit () {
        const btns = self._modal.modal.el.querySelectorAll('.btn');

        for (let i = 0; i < btns.length; i++) {
            btns[i].addEventListener('click',
                () => {
                    saveCookie();
                    hideModal();
                });
        }
    }

    function hideModal () {
        if (self._modal) {
            self._modal.hide();
        }
    }

    function showModal () {
        if (self._modal && !wasCookieSaved()) {
            self._modal.show();
        }
    }

    function getModal () {
        return new MegaModal({
            modalType: 'narrow',
            content: '#landingDialog',
            className: 'u-textCenter',
            clickOutsideToClose: 'false',
            afterShow: () => eventInit()
        });
    }
}

export default new LandingModalMessage();
